// extracted by mini-css-extract-plugin
module.exports = {"about-me-row":"core_about-me-row__BUETN","row":"core_row__1Fim3","copy":"core_copy__1oqZK","about-me":"core_about-me__1bZo3"};